import React, { useState } from "react";
import { SessionPhoto as IPhoto } from "../../../../Shared/GeneratedTypes";
import Photo from "./Photo";
import { Localizations } from "../../../../Shared/sharedTypes";

interface PropTypes {
    photos: IPhoto[];
    localizations: Localizations;
}
export default function Photos({ photos, localizations }: PropTypes) {
    const [selectedPhoto, selectPhoto] = useState<IPhoto | null>(null);

    if (photos.length) {
        let imgs = photos.map((p) => <Photo key={p.id} photo={p} photoSelected={selectPhoto} />);
        return (
            <>
                <div id="photosGrid">{imgs}</div>
                {selectedPhoto && (
                    <div
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            bottom: 0,
                            right: 0,
                            backgroundColor: "#ccc",
                            textAlign: "center",
                            padding: 20,
                        }}
                        onClick={() => selectPhoto(null)}
                    >
                        <img
                            alt="Guide Stream Asset Taken During Session"
                            src={selectedPhoto.url}
                            className="photoFullScreen"
                        ></img>
                    </div>
                )}
            </>
        );
    } else {
        return <div>{localizations.takeAPhoto}</div>;
    }
}

export interface TagDialogProps {
    open: boolean;
    photo: IPhoto | null;
    onClose: () => void;
}
